import {texture, MiniSignal, performNextTick} from "p3";
import definitions from "../../definitions";
import Actor from "./Actor";
import GameScene from "../../scenes/GameScene";

export default class ActorMoleEntrance extends Actor {
    constructor() {
        super(definitions.ACTOR_ID.MOLE_ENTRANCE);

        this.signals.travel = new MiniSignal();

        this.collisionType = definitions.COLLISION_TYPE.RECT;
        this.collisionSize = new PIXI.Point(370, 80);
        this.collisionOffsetX = -150;
        this.collisionOffsetY = -100;

        this.interactable = true;
        this.interactionRadius = 120;
    }

    init() {
        super.init();

        this.signals.travel.once(this._onEnter, this);
        
        this.addViewWithTexture(texture("fm_d_moletown_hole_00"));
    }

    update() {
        super.update();
        
        const d = new P3.Vector2(this.x - GameScene.active.player.x, this.y - GameScene.active.player.y);
        if (d.length < this.interactionRadius) {
            performNextTick(() => this.signals.travel.dispatch());
        }
    }

    onViewAdded() {
        super.onViewAdded();

        this._view.anchor.set(0.5, 1);
    }

    _onEnter() {
        GameScene.active.useLevelShortcut(this.uid);
    }
}